import { ComponentPropsWithRef } from "react";

export const LicenseIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 40C24 40 36.8 33.6 36.8 24V12.8L24 8L11.2 12.8V24C11.2 33.6 24 40 24 40Z"
      stroke="currentColor"
      strokeWidth="3.52"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.3599 20.24L22.2399 29.36L16.5599 23.64L18.3199 21.88L22.3599 25.92L29.6799 18.6L31.3599 20.24Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.96"
    />
  </svg>
);
